import axiosInstance from './axios.instance';

const PlanService = {
  /**
   * Get all active plans
   */
  getAllPlans: async () => {
    try {
      const response = await axiosInstance.get('/plans');
      return response.data;
    } catch (error) {
      console.error('Get all plans error:', error);
      throw error;
    }
  },

  /**
   * Get plan by ID
   */
  getPlanById: async (planId) => {
    try {
      const response = await axiosInstance.get(`/plans/${planId}`);
      return response.data;
    } catch (error) {
      console.error('Get plan by ID error:', error);
      throw error;
    }
  },

  /**
   * Get user's current plan
   */
  getCurrentPlan: async () => {
    try {
      const response = await axiosInstance.get('/plans/user/current');
      return response.data;
    } catch (error) {
      console.error('Get current plan error:', error);
      throw error;
    }
  },

  /**
   * Get usage statistics
   */
  getUsageStats: async () => {
    try {
      const response = await axiosInstance.get('/plans/user/usage');
      return response.data;
    } catch (error) {
      console.error('Get usage stats error:', error);
      throw error;
    }
  },

  /**
   * Get allowed career maps
   */
  getAllowedCareerMaps: async () => {
    try {
      const response = await axiosInstance.get('/plans/user/allowed-career-maps');
      return response.data;
    } catch (error) {
      console.error('Get allowed career maps error:', error);
      throw error;
    }
  },

  /**
   * Compare two plans
   */
  comparePlans: async (planId1, planId2) => {
    try {
      const response = await axiosInstance.get('/plans/compare', {
        params: { planId1, planId2 }
      });
      return response.data;
    } catch (error) {
      console.error('Compare plans error:', error);
      throw error;
    }
  },

  /**
   * Activate a plan directly (without payment)
   */
  activatePlan: async (planId) => {
    try {
      const response = await axiosInstance.post('/subscriptions/activate', {
        planId
      });
      return response.data;
    } catch (error) {
      console.error('Activate plan error:', error);
      throw error;
    }
  },

  /**
   * Get subscription history
   */
  getSubscriptionHistory: async () => {
    try {
      const response = await axiosInstance.get('/subscriptions/history');
      return response.data;
    } catch (error) {
      console.error('Get subscription history error:', error);
      throw error;
    }
  },

  /**
   * Get payment history with detailed transaction information
   */
  getPaymentHistory: async () => {
    try {
      const response = await axiosInstance.get('/subscriptions/payment-history');
      return response.data;
    } catch (error) {
      console.error('Get payment history error:', error);
      throw error;
    }
  },

  /**
   * Create Razorpay order for payment
   */
  createPaymentOrder: async (planId) => {
    try {
      const response = await axiosInstance.post('/subscriptions/create-order', {
        planId
      });
      return response.data;
    } catch (error) {
      console.error('Create payment order error:', error);
      throw error;
    }
  },

  /**
   * Verify Razorpay payment
   */
  verifyPayment: async (paymentData) => {
    try {
      const response = await axiosInstance.post('/subscriptions/verify-payment', paymentData);
      return response.data;
    } catch (error) {
      console.error('Verify payment error:', error);
      throw error;
    }
  }
};

export default PlanService;
